/**
 * @generated SignedSource<<c2bb53640f107f6b60f05989fdc8fbcb>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SearchBar_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ImageSearchModal_user" | "getRecentHistory_user">;
  readonly " $fragmentType": "SearchBar_user";
};
export type SearchBar_user$key = {
  readonly " $data"?: SearchBar_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SearchBar_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SearchBar_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ImageSearchModal_user"
    },
    {
      "kind": "Defer",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "getRecentHistory_user"
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "0425a5df39b4c575c8397445d658aa2e";

export default node;
